/* =====================================================================
   BZT CNC-Tools — die zehn Einzelrechner (Schnittdaten: bzt-cnc-rechner.js)
   Reines Vanilla-JS, keine Abhängigkeiten, keine API-Calls.
   Jeder Rechner hängt an einem eigenen [data-bzt-tool="..."]-Root.

   v2 (23.09.2026): Cockpit-Layout für alle Rechner (Eingaben links, Ergebnis
   mit Live-Grafik rechts, mobile Ergebnisleiste), vollständig zweisprachig
   (DE/EN inkl. Zahlenformat), Bausteine aus bzt-tool-core.js.
   Formeln, URL-Parameter und Clarity-Eventnamen sind unverändert.

   Tools:
     trochoidal : Vorschub-Anhebung bei Chip-Thinning (kleines ae)
     drill      : Bohrer-Drehzahl aus vc + Durchmesser (HSS/VHM)
     vcarve     : V-Carving Tiefe <-> Linienbreite (Geometrie)
     weight     : Materialgewicht aus Maßen + Dichte
     thread     : Gewindebohren Vorschub = Drehzahl × Steigung (DIN 13-1)
     time       : Bearbeitungszeit = Weg / Vorschub + Eilgang-Zuschlag
     nesting    : Plattennutzung — Rasterpacking, Teile/Platte + Verschnitt %
     mrr        : Zeitspanvolumen Q = ap × ae × vf / 1000
     radius     : Bahnradius = Sollradius ∓ Werkzeugradius (Innen/Außen)
     turn       : Drehzahl beim Drehen = (vc*1000)/(π*d), d = Werkstück-Ø

   Werte verifiziert (Workflow tool-data-verify): Bohr-vc-Bereiche je
   Material (HSS-Spiralbohrer) und Materialdichten g/cm³.
   RCTF gilt nur für ae < d/2 — darüber ist der Faktor exakt 1.
   ===================================================================== */
(function () {
  'use strict';

  var IS_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var LOCALE = IS_EN ? 'en-GB' : 'de-DE';
  function t(de, en) { return IS_EN ? en : de; }
  var RPM = t('U/min', 'rpm');
  var NS = 'http://www.w3.org/2000/svg';

  /* Adaptive Rundung: feste Schrittweiten verzerrten kleine Drehzahlen stark
     (Edelstahl Ø30 → echt 84,9 U/min, angezeigt 100 = +17,8 %). (Fix 26.08.2026) */
  function bztRoundAdaptive(v) {
    if (!isFinite(v) || v <= 0) return 0;
    if (v < 100)   return Math.round(v);
    if (v < 1000)  return Math.round(v / 10) * 10;
    if (v < 5000)  return Math.round(v / 50) * 50;
    if (v < 20000) return Math.round(v / 100) * 100;
    return Math.round(v / 500) * 500;
  }
  /* Deep-Link-Werte auf min/max des Eingabefelds begrenzen (Fix 23.09.2026). */
  function setParam(el, raw, allowZero) {
    if (!el || raw === undefined || raw === null) return;
    var v = parseFloat(String(raw).replace(',', '.'));
    if (!isFinite(v) || (allowZero ? v < 0 : v <= 0)) return;
    var mn = parseFloat(el.min), mx = parseFloat(el.max);
    if (isFinite(mn) && v < mn) v = mn;
    if (isFinite(mx) && v > mx) v = mx;
    el.value = String(v);
  }
  function outOfRange(el, v) {
    var mn = parseFloat(el.min), mx = parseFloat(el.max);
    return (isFinite(mn) && v < mn) || (isFinite(mx) && v > mx);
  }
  function rangeHint(el, label, unit) {
    var mn = parseFloat(el.min), mx = parseFloat(el.max);
    var span = isFinite(mn) && isFinite(mx)
      ? t('zwischen ', 'between ') + de(mn, mn % 1 ? 1 : 0) + t(' und ', ' and ') + de(mx, mx % 1 ? 1 : 0)
      : (isFinite(mx) ? t('bis ', 'up to ') + de(mx) : t('ab ', 'from ') + de(mn, mn % 1 ? 2 : 0));
    return '<p class="bzt-calc__hint">' + label + ': ' + t('bitte einen Wert ', 'please enter a value ') + span + (unit ? ' ' + unit : '') + t(' eingeben.', '.') + '</p>';
  }
  function hint(de_, en_) { return '<p class="bzt-calc__hint">' + t(de_, en_) + '</p>'; }
  function de(n, dec) {
    return Number(n).toLocaleString(LOCALE, { minimumFractionDigits: dec || 0, maximumFractionDigits: dec || 0 });
  }
  function num(el) { return parseFloat((el.value || '').replace(',', '.')); }
  function fillSelect(sel, obj, defKey) {
    Object.keys(obj).forEach(function (k) {
      var o = document.createElement('option');
      o.value = k; o.textContent = IS_EN && obj[k].label_en ? obj[k].label_en : obj[k].label;
      sel.appendChild(o);
    });
    if (defKey) sel.value = defKey;
  }
  function L(o) { return IS_EN && o.label_en ? o.label_en : o.label; }
  function H(o) { return IS_EN && o.hint_en ? o.hint_en : o.hint; }

  // Clarity-Event: pro Tool und Seitenaufruf EINMAL, nur bei echter Interaktion.
  var trackedTools = {};
  function track(name) {
    if (trackedTools[name] || !window.clarity) return;
    trackedTools[name] = true;
    try { window.clarity('event', 'tool_used_' + name); } catch (e) {}
  }

  function readParams(fields) {
    var vals = {};
    try {
      var q = new URLSearchParams(location.search);
      fields.forEach(function (f) { if (q.get(f) !== null) vals[f] = q.get(f); });
    } catch (e) {}
    return vals;
  }
  function writeParams(obj) {
    if (!window.history || !window.history.replaceState) return;
    try {
      var q = new URLSearchParams(location.search);
      Object.keys(obj).forEach(function (k) {
        if (obj[k] === '' || obj[k] === null) q.delete(k); else q.set(k, obj[k]);
      });
      var qs = q.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) {}
  }

  // Count-Up der Ergebniszahlen, locale-bewusst (DE 1.234,5 / EN 1,234.5)
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NUM_RE = IS_EN ? /\d[\d,]*(?:\.\d+)?/g : /\d[\d.]*(?:,\d+)?/g;
  function parseLocal(s) { return IS_EN ? parseFloat(s.replace(/,/g, '')) : parseFloat(s.replace(/\./g, '').replace(',', '.')); }
  function decimalsOf(s) { var sep = IS_EN ? '.' : ','; return s.indexOf(sep) >= 0 ? (s.split(sep)[1] || '').length : 0; }
  function animateValues(root) {
    if (prefersReduced) return;
    root.querySelectorAll('.bzt-calc__v').forEach(function (el) {
      var finalHTML = el.innerHTML;
      var segs = [], last = 0, m;
      NUM_RE.lastIndex = 0;
      while ((m = NUM_RE.exec(finalHTML)) !== null) {
        if (m.index > last) segs.push({ num: false, text: finalHTML.slice(last, m.index) });
        segs.push({ num: true, val: parseLocal(m[0]), decimals: decimalsOf(m[0]) });
        last = NUM_RE.lastIndex;
      }
      if (last < finalHTML.length) segs.push({ num: false, text: finalHTML.slice(last) });
      if (!segs.some(function (s) { return s.num; })) return;
      var start = null, dur = 420;
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.innerHTML = segs.map(function (s) {
          return s.num ? (s.val * eased).toLocaleString(LOCALE, { minimumFractionDigits: s.decimals, maximumFractionDigits: s.decimals }) : s.text;
        }).join('');
        if (p < 1) requestAnimationFrame(frame); else el.innerHTML = finalHTML;
      }
      requestAnimationFrame(frame);
    });
  }

  // Kopieren mit Fallback (Fix 23.09.2026)
  function copyText(text, done) {
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done(ok);
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { done(true); }, fallback);
    } else { fallback(); }
  }
  function enhanceCells(out) {
    out.querySelectorAll('.bzt-calc__cell').forEach(function (cell) {
      var v = cell.querySelector('.bzt-calc__v');
      var k = cell.querySelector('.bzt-calc__k');
      if (!v || !k) return;
      var copyVal = v.textContent.replace(/\s+/g, ' ').trim();
      cell.setAttribute('data-copy', copyVal);
      cell.setAttribute('role', 'button');
      cell.setAttribute('tabindex', '0');
      cell.setAttribute('title', t('Klicken zum Kopieren', 'Click to copy'));
      cell.setAttribute('aria-label', k.textContent + ' ' + copyVal + t(' — klicken zum Kopieren', ' — click to copy'));
      function doCopy() {
        copyText(cell.getAttribute('data-copy'), function (ok) {
          var orig = k.innerHTML;
          cell.classList.add(ok ? 'bzt-calc__cell--copied' : 'bzt-calc__cell--copyfail');
          k.textContent = ok ? t('✓ Kopiert', '✓ Copied') : t('Markieren & kopieren', 'Select & copy');
          setTimeout(function () {
            cell.classList.remove('bzt-calc__cell--copied', 'bzt-calc__cell--copyfail');
            k.innerHTML = orig;
          }, 1400);
        });
      }
      cell.addEventListener('click', doCopy);
      cell.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doCopy(); }
      });
    });
  }
  var COPYHINT = '<p class="bzt-calc__copyhint">' + t('Tipp: Klick auf eine Kachel kopiert den Wert.', 'Tip: click a value to copy it.') + '</p>';

  // Sprachpräfix für interne Links (Fix 23.09.2026)
  function loc(path) {
    var r = (typeof window.BZT_ROOT === 'string') ? window.BZT_ROOT : ((location.pathname.match(/^\/(en|de-eu|en-eu)(?=\/|$)/) || [''])[0]);
    if (r === '' || path.charAt(0) !== '/' || path === r || path.indexOf(r + '/') === 0 || path.indexOf(r + '?') === 0 || path.indexOf(r + '#') === 0) return path;
    return r + path;
  }
  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-'); }
  /* Sprachneutrale Kennung je Tool für data-bzt-cta-source (Clarity-Tag tool_inquiry_source): fester Schlüssel statt Slug des
     übersetzten Namens (Sprachqualität W2 g7, t-js-055). Die Schlüssel sind die bisherigen deutschen Slugs, DE-Auswertungen bleiben vergleichbar. */
  var TOOL_IDS = {};
  function toolLabel(de_, en_, id) { var l = t(de_, en_); TOOL_IDS[l] = id; return l; }
  function ctaId(label) { return TOOL_IDS[label] || slug(label); }

  // Anfrage-Zeile nach der Berechnung (vorausgefüllte Nachricht)
  function buildCta(toolLabel, valuesText) {
    var q = 'tool=' + encodeURIComponent(toolLabel) + '&values=' + encodeURIComponent(valuesText);
    return (
      '<div class="bzt-calc__cta">' +
        '<p class="bzt-calc__cta-text">' + t('Unsicher, welche Maschine passt? <strong>Wir beraten Sie gern.</strong>', 'Not sure which machine fits? <strong>We are happy to advise.</strong>') + '</p>' +
        '<div class="bzt-calc__cta-actions">' +
          '<a class="bzt-calc__cta-btn bzt-calc__cta-btn--primary" href="' + loc('/pages/kontakt') + '?' + q + '" data-bzt-cta="tool-inquiry" data-bzt-cta-source="tool-' + ctaId(toolLabel) + '">' + t('Anfrage mit diesen Werten', 'Enquire with these values') + '</a>' +
        '</div>' +
      '</div>'
    );
  }

  // Ergebnis als PNG exportieren (reines Canvas)
  function buildExportBar(out, toolLabel, cells) {
    var bar = document.createElement('div');
    bar.className = 'bzt-calc__exportbar';
    bar.innerHTML =
      '<button type="button" class="bzt-calc__export-btn" data-bzt-export>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15V3M7 10l5 5 5-5M4 21h16"/></svg>' +
        t('Ergebnis als Bild speichern', 'Save result as image') +
      '</button>';
    out.appendChild(bar);
    bar.querySelector('[data-bzt-export]').addEventListener('click', function () { exportResultImage(toolLabel, cells); });
    // Berechnung teilen: Deep-Link der aktuellen Werte kopieren (23.09.2026)
    var share = document.createElement('button');
    share.type = 'button';
    share.className = 'bzt-calc__export-btn';
    share.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1 1M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1-1"/></svg><span>' + t('Link kopieren', 'Copy link') + '</span>';
    share.addEventListener('click', function () {
      copyText(location.href, function (ok) {
        var s = share.querySelector('span');
        s.textContent = ok ? t('✓ Link kopiert', '✓ Link copied') : t('Link in der Adresszeile', 'Use the address bar');
        setTimeout(function () { s.textContent = t('Link kopieren', 'Copy link'); }, 1600);
      });
    });
    bar.appendChild(share);
  }
  function exportResultImage(toolLabel, cells) {
    var W = 900, padX = 56, rowH = 108, headH = 150, footH = 90;
    var Hh = headH + cells.length * rowH + footH;
    var c = document.createElement('canvas');
    c.width = W * 2; c.height = Hh * 2;
    var ctx = c.getContext('2d');
    ctx.scale(2, 2);
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, Hh);
    ctx.fillStyle = '#1a365d'; ctx.fillRect(0, 0, W, 6);
    ctx.fillStyle = '#0a1828'; ctx.font = '700 26px Inter, Arial, sans-serif';
    ctx.fillText('BZT ' + toolLabel, padX, 62);
    ctx.fillStyle = '#5a6b7b'; ctx.font = '400 14px Inter, Arial, sans-serif';
    var d = new Date();
    ctx.fillText('bzt-shop.de · ' + d.toLocaleDateString(LOCALE), padX, 86);
    var y = headH;
    cells.forEach(function (cell) {
      ctx.fillStyle = '#f4f6f9'; roundRect(ctx, padX, y, W - padX * 2, rowH - 18, 12); ctx.fill();
      ctx.fillStyle = '#5f6f80'; ctx.font = '700 12px Inter, Arial, sans-serif';
      ctx.fillText(cell.k.toUpperCase(), padX + 24, y + 34);
      ctx.fillStyle = '#0a1828'; ctx.font = '800 28px Inter, Arial, sans-serif';
      ctx.fillText(cell.v, padX + 24, y + 68);
      y += rowH;
    });
    ctx.fillStyle = '#5a6b7b'; ctx.font = '400 12px Inter, Arial, sans-serif';
    ctx.fillText(t('Unverbindlicher Richtwert. Details: ', 'Non-binding reference value. Details: ') + 'bzt-shop.de' + loc('/pages/tools'), padX, Hh - 40);
    c.toBlob(function (blob) {
      var a = document.createElement('a');
      var url = URL.createObjectURL(blob);
      a.href = url; a.download = 'bzt-' + slug(toolLabel) + '.png';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
    });
  }
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath(); ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }

  // Screenreader: EIN Update pro Berechnung
  function announce(root, text) {
    var live = root.querySelector('[data-bzt-tool-live]');
    if (!live) {
      live = document.createElement('span');
      live.setAttribute('data-bzt-tool-live', '');
      live.setAttribute('aria-live', 'polite');
      live.className = 'bzt-visually-hidden';
      root.appendChild(live);
    }
    live.textContent = text;
  }

  function cell(k, v, unit) {
    return '<div class="bzt-calc__cell"><span class="bzt-calc__k">' + k + '</span>' +
      '<span class="bzt-calc__v">' + v + (unit ? ' <small>' + unit + '</small>' : '') + '</span></div>';
  }
  function grid(cells) { return '<div class="bzt-calc__grid">' + cells.join('') + '</div>'; }
  function note(html) { return '<p class="bzt-calc__note">' + html + '</p>'; }

  /* ---------- Cockpit-Anbindung ----------------------------------------
     Liefert Stepper, Grafik-Host, Ergebnisleiste und die Platzierung der
     Shop-Empfehlung. Ohne Core (alter Cache) läuft alles weiter, nur ohne
     diese Extras. */
  function cockpit(root, barLabel) {
    var core = window.BZTTool;
    var out = root.querySelector('[data-f="out"]');
    var panel = root.querySelector('[data-f="panel"]');
    var api = { viz: root.querySelector('[data-f="viz"]'), bar: null, place: function () {} };
    if (!core || !root.classList.contains('bzt-cockpit')) return api;
    core.steppers(root);
    if (panel) {
      api.bar = core.resultBar(root, panel, barLabel);
      api.place = core.attachRec(panel, out);
    }
    return api;
  }
  function cards(root, select, meta) {
    var host = root.querySelector('[data-f="cards"]');
    if (host && window.BZTTool) window.BZTTool.materialCards(select, host, meta);
  }
  function setBar(api, label, html) {
    if (!api.bar) return;
    if (label) api.bar.label(label);
    api.bar.set(html);
  }
  function finish(root, api) { api.place(); }

  /* ---------- SVG-Helfer für die Live-Grafiken ---------- */
  function svgRoot(host, w, h, labelText) {
    if (!host) return null;
    host.innerHTML = '';
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    s.setAttribute('class', 'bzt-viz__svg');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', labelText || '');
    host.appendChild(s);
    return s;
  }
  function sv(parent, tag, attrs, text) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (text !== undefined) e.textContent = text;
    parent.appendChild(e);
    return e;
  }
  function dimH(s, x1, x2, y, label, cls) {
    sv(s, 'line', { x1: x1, y1: y, x2: x2, y2: y, class: 'vz-dim' });
    sv(s, 'line', { x1: x1, y1: y - 5, x2: x1, y2: y + 5, class: 'vz-dim' });
    sv(s, 'line', { x1: x2, y1: y - 5, x2: x2, y2: y + 5, class: 'vz-dim' });
    sv(s, 'text', { x: (x1 + x2) / 2, y: y - 7, 'text-anchor': 'middle', class: 'vz-label' + (cls ? ' ' + cls : '') }, label);
  }
  function dimV(s, x, y1, y2, label, anchor) {
    sv(s, 'line', { x1: x, y1: y1, x2: x, y2: y2, class: 'vz-dim' });
    sv(s, 'line', { x1: x - 5, y1: y1, x2: x + 5, y2: y1, class: 'vz-dim' });
    sv(s, 'line', { x1: x - 5, y1: y2, x2: x + 5, y2: y2, class: 'vz-dim' });
    sv(s, 'text', { x: anchor === 'start' ? x + 8 : x - 8, y: (y1 + y2) / 2 + 4, 'text-anchor': anchor || 'end', class: 'vz-label' }, label);
  }
  function arrowDefs(s, id) {
    var defs = sv(s, 'defs', {});
    var mk = sv(defs, 'marker', { id: id, viewBox: '0 0 10 10', refX: 8, refY: 5, markerWidth: 8, markerHeight: 8, orient: 'auto' });
    sv(mk, 'path', { d: 'M0,0 L10,5 L0,10 z', class: 'vz-arrowhead' });
  }
  function mm(v) { return de(v, v < 10 ? (v % 1 ? 2 : 0) : (v % 1 ? 1 : 0)) + ' mm'; }

  /* ---------- Tool 1: Trochoidal / Chip-Thinning ---------- */
  function initTrochoidal(root) {
    var dEl = root.querySelector('[data-f="d"]');
    var aeEl = root.querySelector('[data-f="ae"]');
    var fzEl = root.querySelector('[data-f="fz"]');
    var out = root.querySelector('[data-f="out"]');
    if (!dEl || !aeEl || !fzEl || !out) return;
    var LBL = toolLabel('Trochoidal-Rechner', 'Trochoidal calculator', 'trochoidal-rechner');
    var q = readParams(['d', 'ae', 'fz']);
    setParam(dEl, q.d); setParam(aeEl, q.ae); setParam(fzEl, q.fz);
    var api = cockpit(root, t('Korrigierter fz', 'Corrected fz'));

    function viz(d, ae, factor) {
      var s = svgRoot(api.viz, 320, 200, t('Eingriff des Fräsers', 'Tool engagement'));
      if (!s) return;
      var R = 58, cx = 112, cy = 80;
      var aePx = Math.max(1.5, Math.min(2 * R, (ae / d) * 2 * R));
      var edge = cx + R - aePx;
      sv(s, 'rect', { x: edge, y: 8, width: 262 - edge, height: 146, class: 'vz-stock' });
      var cosA = Math.max(-1, Math.min(1, (edge - cx) / R)), half = Math.acos(cosA);
      var y1 = cy - Math.sin(half) * R, y2 = cy + Math.sin(half) * R;
      sv(s, 'path', { d: 'M ' + edge + ' ' + y1 + ' A ' + R + ' ' + R + ' 0 ' + (half > Math.PI / 2 ? 1 : 0) + ' 1 ' + edge + ' ' + y2 + ' Z', class: 'vz-engage' });
      sv(s, 'circle', { cx: cx, cy: cy, r: R, class: 'vz-tool' });
      sv(s, 'circle', { cx: cx, cy: cy, r: 3, class: 'vz-center' });
      dimH(s, edge, cx + R, 166, 'ae ' + mm(ae));
      dimH(s, cx - R, cx + R, 192, 'd ' + mm(d));
      // Faktor-Skala 1×…4×, ab 2,5× Warnbereich
      var mx = 286, mw = 18, top = 22, hgt = 132;
      var fPct = Math.max(0, Math.min(1, (factor - 1) / 3));
      sv(s, 'rect', { x: mx, y: top, width: mw, height: hgt, rx: 4, class: 'vz-meter' });
      sv(s, 'rect', { x: mx, y: top, width: mw, height: hgt * 0.5, rx: 4, class: 'vz-meter-warn' });
      sv(s, 'rect', { x: mx, y: top + hgt * (1 - fPct), width: mw, height: Math.max(3, hgt * fPct), rx: 4, class: factor > 2.5 ? 'vz-meter-fill vz-meter-fill--warn' : 'vz-meter-fill' });
      sv(s, 'text', { x: mx + mw / 2, y: top - 8, 'text-anchor': 'middle', class: 'vz-label' }, '4×');
      sv(s, 'text', { x: mx + mw / 2, y: top + hgt + 14, 'text-anchor': 'middle', class: 'vz-label' }, '1×');
    }

    function update(fromUser) {
      var d = num(dEl), ae = num(aeEl), fz = num(fzEl);
      if (!(d > 0) || !(ae > 0) || !(fz > 0) || ae > d) {
        out.innerHTML = hint('Bitte gültige Werte eingeben (radiale Zustellung ae ≤ Werkzeug-Ø).', 'Please enter valid values (radial depth ae ≤ tool diameter).');
        setBar(api, null, '–'); return;
      }
      var factor, noteText;
      if (ae >= d / 2) {
        factor = 1;
        noteText = t('Bei ae ≥ 50 % des Werkzeug-Durchmessers gibt es kein Chip-Thinning — die maximale Spandicke entspricht bereits dem programmierten Zahnvorschub. Den Vorschub hier <strong>nicht</strong> anheben (Faktor 1,00).',
          'At ae ≥ 50% of the tool diameter there is no chip thinning — the maximum chip thickness already equals the programmed feed per tooth. Do <strong>not</strong> increase the feed here (factor 1.00).');
      } else {
        factor = d / (2 * Math.sqrt(ae * (d - ae)));
        var pct = (factor - 1) * 100;
        noteText = t('Bei ae = ' + de(ae / d * 100) + ' % des Durchmessers darf der Zahnvorschub um etwa ' + de(Math.max(0, pct)) + ' % angehoben werden, damit die effektive Spandicke gleich bleibt. ',
          'At ae = ' + de(ae / d * 100) + '% of the diameter the feed per tooth can be increased by about ' + de(Math.max(0, pct)) + '% to keep the effective chip thickness constant. ') +
          (factor > 1.05 ? t('Voraussetzung: Maschine und Spindel liefern den höheren Vorschub sauber.', 'This requires the machine and spindle to deliver the higher feed reliably.')
                         : t('Bei großer radialer Zustellung ist kaum Korrektur nötig.', 'With a large radial depth hardly any correction is needed.'));
      }
      if (factor > 2.5) {
        noteText += t(' <strong>Achtung:</strong> Bei so kleiner Zustellung (ae unter ca. 4 % des Durchmessers) wird der Faktor unrealistisch groß. In der Praxis den korrigierten Zahnvorschub nicht über das 2- bis 2,5-fache des Katalogwerts anheben und die Herstellerangabe für HSM-Bahnen prüfen.',
          ' <strong>Caution:</strong> with such a small radial depth (ae below approx. 4% of the diameter) the factor becomes unrealistically large. In practice do not raise the corrected feed per tooth above 2 to 2.5 times the catalogue value, and check the manufacturer data for HSM paths.');
      }
      var fzKorr = fz * factor;
      var vFactor = de(factor, 2) + '×';
      var vFz = de(fzKorr, 3) + ' ' + t('mm/Zahn', 'mm/tooth');
      out.innerHTML = grid([
        cell(t('Korrigierter f<sub>z</sub>', 'Corrected f<sub>z</sub>'), de(fzKorr, 3), t('mm/Zahn', 'mm/tooth')),
        cell(t('Korrektur-Faktor', 'Correction factor'), vFactor)
      ]) + COPYHINT + note(noteText) +
        buildCta(LBL, t('Korrektur-Faktor ', 'Correction factor ') + vFactor + ' · ' + t('Korrigierter fz ', 'Corrected fz ') + vFz);
      enhanceCells(out); animateValues(out);
      announce(root, t('Korrektur-Faktor ', 'Correction factor ') + de(factor, 2) + '. ' + t('Korrigierter Zahnvorschub ', 'Corrected feed per tooth ') + vFz + '.');
      buildExportBar(out, LBL, [{ k: t('Korrektur-Faktor', 'Correction factor'), v: vFactor }, { k: t('Korrigierter fz', 'Corrected fz'), v: vFz }]);
      viz(d, ae, factor);
      setBar(api, null, de(fzKorr, 3) + ' <small>' + t('mm/Zahn', 'mm/tooth') + '</small> · ' + vFactor);
      finish(root, api);
      if (fromUser) { track('trochoidal'); writeParams({ d: dEl.value, ae: aeEl.value, fz: fzEl.value }); }
    }
    [dEl, aeEl, fzEl].forEach(function (el) { el.addEventListener('input', function () { update(true); }); });
    update(false);
  }

  /* ---------- Tool 2: Bohrer-Drehzahl ---------- */
  var DRILL = {
    holz:       { label: 'Holz (Weich-/Hartholz)', label_en: 'Wood (soft/hardwood)', vc: [100, 250],
                  hint: 'Hohe Drehzahl möglich; bei Austritt langsamer, sonst Ausriss. Harte Hölzer eher am unteren Ende (Brandgefahr).',
                  hint_en: 'High speed possible; slow down on exit to avoid tear-out. Hardwoods towards the lower end (risk of burning).' },
    kunststoff: { label: 'Kunststoff (PMMA, POM, PVC)', label_en: 'Plastics (PMMA, POM, PVC)', vc: [30, 90],
                  hint: 'Scharfe Werkzeuge, gute Spanabfuhr. PMMA wärmeempfindlich — unteres Ende, kühlen, langsam austreten.',
                  hint_en: 'Sharp tools, good chip evacuation. PMMA is heat-sensitive — lower end, cool, exit slowly.' },
    aluminium:  { label: 'Aluminium', label_en: 'Aluminium', vc: [60, 100],
                  hint: 'Gut bohrbar; großer Drallwinkel und Schmierung gegen Verkleben.',
                  hint_en: 'Drills well; high helix angle and lubrication against built-up edge.' },
    messing:    { label: 'Messing', label_en: 'Brass', vc: [50, 90],
                  hint: 'Bohrer mit reduziertem Spanwinkel verhindert Einhaken/Selbstvorschub.',
                  hint_en: 'A drill with reduced rake angle prevents grabbing / self-feeding.' },
    baustahl:   { label: 'Baustahl (S235)', label_en: 'Mild steel (S235)', vc: [30, 40],
                  hint: 'Kühlschmierung empfohlen; gleichmäßiger Vorschub.',
                  hint_en: 'Coolant recommended; steady feed.' },
    edelstahl:  { label: 'Edelstahl (V2A/V4A)', label_en: 'Stainless steel (304/316)', vc: [8, 14],
                  hint: 'Niedrige Drehzahl, hoher Vorschub, Kühlung Pflicht — nicht reiben (Kaltverfestigung).',
                  hint_en: 'Low speed, high feed, coolant mandatory — do not rub (work hardening).' }
  };
  function initDrill(root) {
    var matEl = root.querySelector('[data-f="mat"]');
    var dEl = root.querySelector('[data-f="d"]');
    var out = root.querySelector('[data-f="out"]');
    if (!matEl || !dEl || !out) return;
    fillSelect(matEl, DRILL, 'aluminium');
    var toolEls = root.querySelectorAll('[data-f="tool"]');
    var LBL = toolLabel('Bohr-Drehzahl-Rechner', 'Drilling speed calculator', 'bohr-drehzahl-rechner');

    var q = readParams(['mat', 'd', 'w']);
    if (q.mat && DRILL[q.mat]) matEl.value = q.mat;
    setParam(dEl, q.d);
    if (q.w === 'vhm') toolEls.forEach(function (r) { r.checked = r.value === 'vhm'; });

    cards(root, matEl, function (k) { return 'vc ' + DRILL[k].vc[0] + '–' + DRILL[k].vc[1] + ' m/min'; });
    var api = cockpit(root, t('Bohrer-Drehzahl', 'Drill speed'));
    var gauge = api.viz && window.BZTTool ? window.BZTTool.gauge(api.viz) : null;
    function toolKind() { var k = 'hss'; toolEls.forEach(function (r) { if (r.checked) k = r.value; }); return k; }

    function update(fromUser) {
      var m = DRILL[matEl.value], d = num(dEl);
      if (!m || !(d > 0)) { out.innerHTML = hint('Bitte Bohrer-Durchmesser eingeben.', 'Please enter the drill diameter.'); setBar(api, null, '–'); return; }
      if (outOfRange(dEl, d)) { out.innerHTML = rangeHint(dEl, t('Bohrer-Ø', 'Drill Ø'), 'mm'); setBar(api, null, '–'); return; }
      var vhm = toolKind() === 'vhm';
      // VHM: Näherung aus dem bestehenden Hinweis "etwa die 2- bis 3-fache Drehzahl"
      var fLo = vhm ? 2 : 1, fHi = vhm ? 3 : 1;
      var nLow = bztRoundAdaptive((m.vc[0] * fLo * 1000) / (Math.PI * d));
      var nHigh = bztRoundAdaptive((m.vc[1] * fHi * 1000) / (Math.PI * d));
      var range = nLow === nHigh ? de(nLow) : de(nLow) + '–' + de(nHigh);
      var label = vhm ? t('Bohrer-Drehzahl (VHM, Näherung)', 'Drill speed (solid carbide, approximation)') : t('Bohrer-Drehzahl (HSS)', 'Drill speed (HSS)');
      var dTxt = de(d, d % 1 ? 1 : 0) + ' mm';
      out.innerHTML = grid([
        cell(label, range, RPM),
        cell(t('Schnittgeschwindigkeit v<sub>c</sub>', 'Cutting speed v<sub>c</sub>'), de(m.vc[0] * fLo) + '–' + de(m.vc[1] * fHi), 'm/min')
      ]) + COPYHINT +
        note(H(m) + (vhm
          ? t(' VHM-Werte sind hier aus der HSS-Spanne abgeleitet (2- bis 3-fach) und nur ein Startpunkt; maßgeblich ist die Herstellerangabe des Bohrers.',
              ' Solid carbide values are derived here from the HSS range (2 to 3 times) and are only a starting point; the drill manufacturer\'s data takes precedence.')
          : t(' VHM-Bohrer vertragen etwa die 2- bis 3-fache Drehzahl.', ' Solid carbide drills tolerate roughly 2 to 3 times the speed.'))) +
        buildCta(LBL, label + ' ' + range + ' ' + RPM + ' · Ø ' + dTxt + ' · ' + L(m));
      enhanceCells(out); animateValues(out);
      announce(root, label + ' ' + range + ' ' + t('Umdrehungen pro Minute.', 'revolutions per minute.'));
      buildExportBar(out, LBL, [{ k: label, v: range + ' ' + RPM }, { k: t('Werkstoff · Ø', 'Material · Ø'), v: L(m) + ' · ' + dTxt }]);
      if (gauge) gauge.update({ lo: nLow, hi: nHigh, limit: nHigh > 12000 ? 24000 : null,
        bandLabel: (vhm ? t('VHM ', 'Solid carbide ') : 'HSS ') + range + ' ' + RPM,
        limitLabel: t('24.000 U/min: übliche HF-Spindel', '24,000 rpm: typical HF spindle') });
      setBar(api, label, range + ' <small>' + RPM + '</small>');
      finish(root, api);
      if (fromUser) { track('bohren'); writeParams({ mat: matEl.value, d: dEl.value, w: vhm ? 'vhm' : '' }); }
    }
    matEl.addEventListener('change', function () { update(true); });
    dEl.addEventListener('input', function () { update(true); });
    toolEls.forEach(function (r) { r.addEventListener('change', function () { update(true); }); });
    update(false);
  }

  /* ---------- Tool 3: V-Carving Geometrie ---------- */
  // T = (W/2) / tan(A/2) ; W = 2*T*tan(A/2)
  var ANGLES = {
    '30':  { label: '30°', hint: 'sehr fein', hint_en: 'very fine' },
    '60':  { label: '60°', hint: 'universell', hint_en: 'universal' },
    '90':  { label: '90°', hint: 'robust', hint_en: 'robust' },
    '120': { label: '120°', hint: 'flach', hint_en: 'shallow' }
  };
  function initVcarve(root) {
    var angEl = root.querySelector('[data-f="angle"]');
    var modeEls = root.querySelectorAll('[data-f="mode"]');
    var valEl = root.querySelector('[data-f="val"]');
    var valLabel = root.querySelector('[data-f="vallabel"]');
    var out = root.querySelector('[data-f="out"]');
    if (!angEl || !valEl || !out) return;
    var LBL = toolLabel('V-Carving-Rechner', 'V-carving calculator', 'v-carving-rechner');
    if (!angEl.options.length) fillSelect(angEl, ANGLES, '60');

    var q = readParams(['mode', 'a', 'v']);
    if (q.mode === 'depth' || q.mode === 'width') modeEls.forEach(function (r) { r.checked = r.value === q.mode; });
    if (q.a && ANGLES[q.a]) angEl.value = q.a;
    setParam(valEl, q.v);
    cards(root, angEl, function (k) { return H(ANGLES[k]); });
    var api = cockpit(root, 'V-Carving');

    function mode() { var m = 'width'; modeEls.forEach(function (r) { if (r.checked) m = r.value; }); return m; }
    function syncLabel() {
      if (valLabel) valLabel.textContent = mode() === 'width' ? t('Gewünschte Linienbreite', 'Desired line width') : t('Eintauchtiefe', 'Plunge depth');
    }
    function viz(A, W, T) {
      var s = svgRoot(api.viz, 320, 190, t('Querschnitt der V-Nut', 'V-groove cross-section'));
      if (!s) return;
      var surf = 62, cx = 150;
      var sc = Math.min(200 / W, 100 / T);
      var w = W * sc, h = T * sc;
      sv(s, 'rect', { x: 14, y: surf, width: 292, height: 120, class: 'vz-stock' });
      sv(s, 'path', { d: 'M ' + (cx - w / 2) + ' ' + surf + ' L ' + cx + ' ' + (surf + h) + ' L ' + (cx + w / 2) + ' ' + surf + ' Z', class: 'vz-groove' });
      // Fräser: V-Flanken laufen exakt durch die Nutkanten an der Oberfläche und
      // setzen sich darüber fort; bei stumpfen Winkeln kürzer, damit nichts aus dem Bild ragt.
      var tanH = Math.tan(A / 2 * Math.PI / 180);
      var up = Math.max(10, Math.min(42, (150 - w / 2) / tanH));
      var top = surf - up, halfTop = w / 2 + up * tanH;
      var sh = Math.max(8, Math.min(22, halfTop * 0.45));
      sv(s, 'path', { d: 'M ' + (cx - sh) + ' 2 L ' + (cx - sh) + ' ' + top + ' L ' + (cx - halfTop) + ' ' + top + ' L ' + cx + ' ' + (surf + h) + ' L ' + (cx + halfTop) + ' ' + top + ' L ' + (cx + sh) + ' ' + top + ' L ' + (cx + sh) + ' 2', class: 'vz-cutter' });
      dimH(s, cx - w / 2, cx + w / 2, surf - 6, t('B ', 'W ') + mm(W));
      dimV(s, cx + w / 2 + 20, surf, surf + h, t('T ', 'D ') + mm(T), 'start');
      sv(s, 'text', { x: 30, y: surf + 20, class: 'vz-label vz-label--strong' }, 'V' + A + '°');
    }
    function update(fromUser) {
      var A = parseFloat(angEl.value), v = num(valEl), half = (A / 2) * Math.PI / 180;
      if (!(A > 0) || !(v > 0)) { out.innerHTML = hint('Bitte einen Wert eingeben.', 'Please enter a value.'); setBar(api, null, '–'); return; }
      if (outOfRange(valEl, v)) { out.innerHTML = rangeHint(valEl, t('Wert', 'Value'), 'mm'); setBar(api, null, '–'); return; }
      var resK, resV, W, T;
      if (mode() === 'width') { resK = t('Eintauchtiefe', 'Plunge depth'); resV = (v / 2) / Math.tan(half); W = v; T = resV; }
      else { resK = t('Linienbreite', 'Line width'); resV = 2 * v * Math.tan(half); W = resV; T = v; }
      var vResult = de(resV, 2) + ' mm';
      out.innerHTML = grid([
        cell(resK + ' (V' + A + '°)', de(resV, 2), 'mm'),
        cell(mode() === 'width' ? t('Linienbreite (Eingabe)', 'Line width (input)') : t('Eintauchtiefe (Eingabe)', 'Plunge depth (input)'), de(v, 2), 'mm')
      ]) + COPYHINT +
        note(t('Reine Geometrie des V-Fräsers. Bei breiteren Linien als der Fräser-Durchmesser fährt die CAM-Software mehrere Bahnen. Spitzere Winkel = feinere, tiefere Linien.',
               'This is purely the geometry of the V-bit. For lines wider than the cutter diameter the CAM software runs several passes. Sharper angles = finer, deeper lines.')) +
        buildCta(LBL, resK + ' (V' + A + '°) ' + vResult);
      enhanceCells(out); animateValues(out);
      announce(root, resK + ' ' + vResult + '.');
      buildExportBar(out, LBL, [{ k: resK + ' (V' + A + '°)', v: vResult }]);
      viz(A, W, T);
      setBar(api, resK + ' (V' + A + '°)', de(resV, 2) + ' <small>mm</small>');
      finish(root, api);
      if (fromUser) { track('vcarving'); writeParams({ mode: mode(), a: angEl.value, v: valEl.value }); }
    }
    angEl.addEventListener('change', function () { update(true); });
    valEl.addEventListener('input', function () { update(true); });
    modeEls.forEach(function (r) { r.addEventListener('change', function () { syncLabel(); update(true); }); });
    syncLabel();
    update(false);
  }

  /* ---------- Tool 4: Materialgewicht ---------- */
  var DENSITY = {
    aluminium:  { label: 'Aluminium', label_en: 'Aluminium', rho: 2.70 },
    stahl:      { label: 'Stahl / Baustahl', label_en: 'Steel / mild steel', rho: 7.85 },
    edelstahl:  { label: 'Edelstahl (V2A)', label_en: 'Stainless steel (304)', rho: 7.90 },
    messing:    { label: 'Messing', label_en: 'Brass', rho: 8.50 },
    kupfer:     { label: 'Kupfer', label_en: 'Copper', rho: 8.96 },
    pmma:       { label: 'Acrylglas (PMMA)', label_en: 'Acrylic (PMMA)', rho: 1.18 },
    pom:        { label: 'POM (Delrin)', label_en: 'POM (Delrin)', rho: 1.42 },
    pvc:        { label: 'PVC (hart)', label_en: 'PVC (rigid)', rho: 1.40 },
    weichholz:  { label: 'Weichholz (Fichte)', label_en: 'Softwood (spruce)', rho: 0.50 },
    hartholz:   { label: 'Hartholz (Eiche/Buche)', label_en: 'Hardwood (oak/beech)', rho: 0.70 },
    mdf:        { label: 'MDF', label_en: 'MDF', rho: 0.75 },
    multiplex:  { label: 'Multiplex / Sperrholz', label_en: 'Plywood', rho: 0.68 }
  };
  function initWeight(root) {
    var matEl = root.querySelector('[data-f="mat"]');
    var lEl = root.querySelector('[data-f="l"]');
    var bEl = root.querySelector('[data-f="b"]');
    var hEl = root.querySelector('[data-f="h"]');
    var out = root.querySelector('[data-f="out"]');
    if (!matEl || !lEl || !bEl || !hEl || !out) return;
    fillSelect(matEl, DENSITY, 'aluminium');
    var LBL = toolLabel('Materialgewicht-Rechner', 'Material weight calculator', 'materialgewicht-rechner');

    var q = readParams(['mat', 'l', 'b', 'h']);
    if (q.mat && DENSITY[q.mat]) matEl.value = q.mat;
    setParam(lEl, q.l); setParam(bEl, q.b); setParam(hEl, q.h);
    cards(root, matEl, function (k) { return de(DENSITY[k].rho, 2) + ' g/cm³'; });
    var api = cockpit(root, t('Gewicht', 'Weight'));

    function viz(Lm, Bm, Hm) {
      var s = svgRoot(api.viz, 320, 196, t('Quader mit Maßen', 'Block with dimensions'));
      if (!s) return;
      var mx = Math.max(Lm, Bm, Hm);
      var l = Math.max(24, 170 * Lm / mx), b = Math.max(14, 76 * Bm / mx), h = Math.max(8, 86 * Hm / mx);
      var ox = 64, oy = 156, dx = b * 0.87, dy = b * 0.5;
      function P(x, y) { return x + ' ' + y; }
      sv(s, 'path', { d: 'M ' + P(ox, oy) + ' L ' + P(ox + l, oy) + ' L ' + P(ox + l, oy - h) + ' L ' + P(ox, oy - h) + ' Z', class: 'vz-face vz-face--front' });
      sv(s, 'path', { d: 'M ' + P(ox + l, oy) + ' L ' + P(ox + l + dx, oy - dy) + ' L ' + P(ox + l + dx, oy - dy - h) + ' L ' + P(ox + l, oy - h) + ' Z', class: 'vz-face vz-face--side' });
      sv(s, 'path', { d: 'M ' + P(ox, oy - h) + ' L ' + P(ox + l, oy - h) + ' L ' + P(ox + l + dx, oy - dy - h) + ' L ' + P(ox + dx, oy - dy - h) + ' Z', class: 'vz-face vz-face--top' });
      dimH(s, ox, ox + l, oy + 24, 'L ' + mm(Lm));
      sv(s, 'text', { x: ox + l + dx / 2 + 12, y: oy - dy / 2 + 14, class: 'vz-label' }, t('B ', 'W ') + mm(Bm));
      dimV(s, ox - 12, oy - h, oy, 'H ' + mm(Hm));
    }
    function update(fromUser) {
      var m = DENSITY[matEl.value], Lm = num(lEl), Bm = num(bEl), Hm = num(hEl);
      if (!m || !(Lm > 0) || !(Bm > 0) || !(Hm > 0)) {
        out.innerHTML = hint('Bitte Länge, Breite und Dicke (mm) eingeben.', 'Please enter length, width and thickness (mm).'); setBar(api, null, '–'); return;
      }
      var cm3 = (Lm * Bm * Hm) / 1000;
      var kg = cm3 * m.rho / 1000;
      var g = kg * 1000;
      var display = kg >= 1 ? de(kg, 2) + ' kg' : (g >= 10 ? de(g, 0) + ' g' : (g >= 0.05 ? de(g, 1) + ' g' : '< ' + de(0.1, 1) + ' g'));
      var volDec = cm3 < 10 ? 1 : 0;
      var vVol = de(cm3, volDec) + ' cm³';
      out.innerHTML = grid([
        cell(t('Gewicht', 'Weight'), display),
        cell(t('Volumen', 'Volume'), de(cm3, volDec), 'cm³'),
        cell(t('Dichte', 'Density'), de(m.rho, 2), 'g/cm³')
      ]) + COPYHINT +
        note(t('Berechnet für einen Vollquader. Bei Profilen, Bohrungen oder Taschen ist das tatsächliche Gewicht geringer.',
               'Calculated for a solid block. With profiles, holes or pockets the actual weight is lower.')) +
        buildCta(LBL, t('Gewicht ', 'Weight ') + display + ' · ' + t('Volumen ', 'Volume ') + vVol + ' · ' + L(m));
      enhanceCells(out); animateValues(out);
      announce(root, t('Gewicht ', 'Weight ') + display + '. ' + t('Volumen ', 'Volume ') + vVol + '.');
      buildExportBar(out, LBL, [{ k: t('Gewicht', 'Weight'), v: display }, { k: t('Volumen', 'Volume'), v: vVol }, { k: t('Werkstoff', 'Material'), v: L(m) }]);
      viz(Lm, Bm, Hm);
      setBar(api, t('Gewicht · ', 'Weight · ') + L(m), display);
      finish(root, api);
      if (fromUser) { track('gewicht'); writeParams({ mat: matEl.value, l: lEl.value, b: bEl.value, h: hEl.value }); }
    }
    matEl.addEventListener('change', function () { update(true); });
    [lEl, bEl, hEl].forEach(function (el) { el.addEventListener('input', function () { update(true); }); });
    update(false);
  }

  /* ---------- Tool 5: Gewindebohren Vorschub ---------- */
  // Regelgewinde-Steigungen nach DIN 13-1 [mm]; Vorschub exakt n × Steigung.
  var THREADS = {
    m2:  { label: 'M2', p: 0.40 },  m25: { label: 'M2,5', label_en: 'M2.5', p: 0.45 },
    m3:  { label: 'M3', p: 0.50 },  m4:  { label: 'M4', p: 0.70 },
    m5:  { label: 'M5', p: 0.80 },  m6:  { label: 'M6', p: 1.00 },
    m8:  { label: 'M8', p: 1.25 },  m10: { label: 'M10', p: 1.50 },
    m12: { label: 'M12', p: 1.75 }, m16: { label: 'M16', p: 2.00 }
  };
  function initThread(root) {
    var mEl = root.querySelector('[data-f="m"]');
    var nEl = root.querySelector('[data-f="n"]');
    var out = root.querySelector('[data-f="out"]');
    if (!mEl || !nEl || !out) return;
    fillSelect(mEl, THREADS, 'm6');
    var LBL = toolLabel('Gewinde-Vorschub-Rechner', 'Thread feed calculator', 'gewinde-vorschub-rechner');

    var q = readParams(['m', 'n']);
    if (q.m && THREADS[q.m]) mEl.value = q.m;
    setParam(nEl, q.n);
    cards(root, mEl, function (k) { return 'P ' + de(THREADS[k].p, 2) + ' mm'; });
    var api = cockpit(root, t('Vorschub', 'Feed'));

    function viz(p, n, vf) {
      var s = svgRoot(api.viz, 320, 170, t('Gewindeprofil mit Steigung', 'Thread profile with pitch'));
      if (!s) return;
      arrowDefs(s, 'bztArrowT');
      var pitchPx = 50, y0 = 112, depth = 28, x0 = 35;
      var d = 'M ' + x0 + ' ' + y0;
      for (var i = 0; i < 5; i++) {
        var x = x0 + i * pitchPx;
        d += ' L ' + (x + pitchPx / 2) + ' ' + (y0 - depth) + ' L ' + (x + pitchPx) + ' ' + y0;
      }
      sv(s, 'path', { d: d + ' L ' + (x0 + 5 * pitchPx) + ' 156 L ' + x0 + ' 156 Z', class: 'vz-stock' });
      sv(s, 'path', { d: d, class: 'vz-profile' });
      dimH(s, x0 + pitchPx / 2, x0 + pitchPx * 1.5, y0 - depth - 12, 'P ' + de(p, 2) + ' mm');
      sv(s, 'line', { x1: 40, y1: 34, x2: 280, y2: 34, class: 'vz-arrow', 'marker-end': 'url(#bztArrowT)' });
      sv(s, 'text', { x: 160, y: 24, 'text-anchor': 'middle', class: 'vz-label vz-label--strong' }, 'vf = ' + de(n) + ' × ' + de(p, 2) + ' = ' + de(vf) + ' mm/min');
    }
    function update(fromUser) {
      var th = THREADS[mEl.value], n = num(nEl);
      if (!th || !(n > 0)) { out.innerHTML = hint('Bitte Drehzahl eingeben.', 'Please enter the speed.'); setBar(api, null, '–'); return; }
      if (outOfRange(nEl, n)) { out.innerHTML = rangeHint(nEl, t('Drehzahl', 'Speed'), RPM); setBar(api, null, '–'); return; }
      var vf = n * th.p;
      var vVf = de(vf, 0) + ' mm/min';
      var vP = de(th.p, 2) + ' ' + t('mm/U', 'mm/rev');
      out.innerHTML = grid([
        cell(t('Vorschub v<sub>f</sub>', 'Feed v<sub>f</sub>'), de(vf, 0), 'mm/min'),
        cell(t('Steigung P', 'Pitch P'), de(th.p, 2), t('mm/U', 'mm/rev')),
        cell(t('Gewinde · Drehzahl', 'Thread · speed'), L(th) + ' · ' + de(n), RPM)
      ]) + COPYHINT +
        note(t('Beim Maschinengewindebohren muss der Vorschub <strong>exakt</strong> Drehzahl × Steigung betragen — starr synchronisiert (Rigid Tapping) oder mit Ausgleichsfutter. Am Gewindegrund Drehrichtung umkehren und mit demselben Vorschub herausfahren.',
               'For machine tapping the feed must be <strong>exactly</strong> speed × pitch — rigidly synchronised (rigid tapping) or with a floating tap holder. Reverse at the bottom of the thread and retract at the same feed.')) +
        buildCta(LBL, L(th) + ' · ' + t('Vorschub ', 'Feed ') + vVf + ' · ' + t('Steigung ', 'Pitch ') + vP);
      enhanceCells(out); animateValues(out);
      announce(root, t('Vorschub ', 'Feed ') + vVf + t(' bei Steigung ', ' at pitch ') + vP + '.');
      buildExportBar(out, LBL, [{ k: t('Vorschub vf', 'Feed vf'), v: vVf }, { k: t('Steigung P', 'Pitch P'), v: vP }]);
      viz(th.p, n, vf);
      setBar(api, t('Vorschub · ', 'Feed · ') + L(th), de(vf, 0) + ' <small>mm/min</small>');
      finish(root, api);
      if (fromUser) { track('gewinde'); writeParams({ m: mEl.value, n: nEl.value }); }
    }
    mEl.addEventListener('change', function () { update(true); });
    nEl.addEventListener('input', function () { update(true); });
    update(false);
  }

  /* ---------- Tool 6: Bearbeitungszeit-Schätzung ---------- */
  // Erst runden, dann zerlegen (vorher "1 h 60 min"). (Fix 23.09.2026)
  function fmtMinutes(min) {
    if (min * 60 < 59.5) return de(Math.max(1, Math.round(min * 60)), 0) + ' s';
    if (min < 9.95) return de(min, 1) + ' min';
    var tt = Math.round(min);
    if (tt < 60) return de(tt, 0) + ' min';
    var h = Math.floor(tt / 60), m = tt % 60;
    return h + ' h ' + ('0' + m).slice(-2) + ' min';
  }
  function initTime(root) {
    var lenEl = root.querySelector('[data-f="len"]');
    var vfEl = root.querySelector('[data-f="vf"]');
    var passesEl = root.querySelector('[data-f="passes"]');
    var overheadEl = root.querySelector('[data-f="overhead"]');
    var qtyEl = root.querySelector('[data-f="qty"]');
    var out = root.querySelector('[data-f="out"]');
    if (!lenEl || !vfEl || !passesEl || !out) return;
    var LBL = toolLabel('Bearbeitungszeit-Rechner', 'Machining time calculator', 'bearbeitungszeit-rechner');

    var q = readParams(['len', 'vf', 'passes', 'overhead', 'qty']);
    setParam(lenEl, q.len); setParam(vfEl, q.vf); setParam(passesEl, q.passes);
    setParam(overheadEl, q.overhead, true); setParam(qtyEl, q.qty);
    var api = cockpit(root, t('Zeit pro Werkstück', 'Time per part'));

    function viz(cut, extra, qty) {
      var s = svgRoot(api.viz, 320, 104, t('Zeitanteile', 'Time breakdown'));
      if (!s) return;
      var total = cut + extra, x0 = 12, w = 296;
      var wc = total > 0 ? w * cut / total : w;
      sv(s, 'rect', { x: x0, y: 34, width: w, height: 28, rx: 6, class: 'vz-meter' });
      if (extra > 0) sv(s, 'rect', { x: x0, y: 34, width: w, height: 28, rx: 6, class: 'vz-meter-extra' });
      sv(s, 'rect', { x: x0, y: 34, width: Math.max(4, wc), height: 28, rx: 6, class: 'vz-meter-fill' });
      sv(s, 'text', { x: x0, y: 24, class: 'vz-label vz-label--strong' }, t('Schnittzeit ', 'Cutting ') + fmtMinutes(cut));
      if (extra > 0) sv(s, 'text', { x: x0 + w, y: 24, 'text-anchor': 'end', class: 'vz-label' }, t('+ Zuschlag ', '+ allowance ') + fmtMinutes(extra));
      sv(s, 'text', { x: x0, y: 86, class: 'vz-label' }, qty > 1 ? (qty + t(' Stück gesamt: ', ' parts in total: ') + fmtMinutes(total * qty)) : t('1 Werkstück', '1 part'));
    }
    function update(fromUser) {
      var len = num(lenEl), vf = num(vfEl), passes = parseInt(passesEl.value, 10);
      var overhead = overheadEl ? num(overheadEl) : 0;
      if (!(overhead >= 0)) overhead = 0;
      if (overhead > 100) overhead = 100;
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!(len > 0) || !(vf > 0) || !(passes > 0)) {
        out.innerHTML = hint('Bitte Bearbeitungslänge und Vorschub eingeben.', 'Please enter machining length and feed.'); setBar(api, null, '–'); return;
      }
      var baseMin = (len / vf) * passes;
      var withOverheadMin = baseMin * (1 + overhead / 100);
      var totalMin = withOverheadMin * (qty > 0 ? qty : 1);
      var vSingle = fmtMinutes(withOverheadMin);
      var showTotal = qty > 1;
      var vTotal = fmtMinutes(totalMin);
      var cells = [cell(t('Zeit pro Werkstück', 'Time per part'), vSingle)];
      if (showTotal) cells.push(cell(t('Gesamtzeit (', 'Total time (') + qty + t(' Stk.)', ' pcs)'), vTotal));
      cells.push(cell(t('Reine Schnittzeit', 'Net cutting time'), fmtMinutes(baseMin)));
      out.innerHTML = grid(cells) + COPYHINT +
        note(t('Reine Schnittzeit-Schätzung aus Weg ÷ Vorschub, plus ' + de(overhead, 0) + ' % Zuschlag für Eilgänge und Anfahrten. Werkzeugwechsel, Materialwechsel und Rüstzeiten sind nicht enthalten — für eine verbindliche Kalkulation empfiehlt sich eine CAM-Simulation.',
               'Cutting time estimate from path ÷ feed, plus ' + de(overhead, 0) + '% allowance for rapids and approaches. Tool changes, material changes and set-up are not included — use a CAM simulation for a reliable estimate.')) +
        buildCta(LBL, t('Zeit pro Werkstück ', 'Time per part ') + vSingle + (showTotal ? ' · ' + t('Gesamtzeit (', 'Total time (') + qty + t(' Stk.) ', ' pcs) ') + vTotal : ''));
      enhanceCells(out); animateValues(out);
      announce(root, t('Zeit pro Werkstück ', 'Time per part ') + vSingle + (showTotal ? '. ' + t('Gesamtzeit für ', 'Total time for ') + qty + t(' Stück: ', ' parts: ') + vTotal + '.' : '.'));
      var exportCells = [{ k: t('Zeit pro Werkstück', 'Time per part'), v: vSingle }];
      if (showTotal) exportCells.push({ k: t('Gesamtzeit (', 'Total time (') + qty + t(' Stk.)', ' pcs)'), v: vTotal });
      buildExportBar(out, LBL, exportCells);
      viz(baseMin, withOverheadMin - baseMin, qty > 0 ? qty : 1);
      setBar(api, showTotal ? t('Pro Werkstück · gesamt ', 'Per part · total ') + vTotal : t('Zeit pro Werkstück', 'Time per part'), vSingle);
      finish(root, api);
      if (fromUser) {
        track('zeit');
        writeParams({ len: lenEl.value, vf: vfEl.value, passes: passesEl.value, overhead: overheadEl ? overheadEl.value : '', qty: qtyEl ? qtyEl.value : '' });
      }
    }
    [lenEl, vfEl, passesEl].forEach(function (el) { el.addEventListener('input', function () { update(true); }); });
    if (overheadEl) overheadEl.addEventListener('input', function () { update(true); });
    if (qtyEl) qtyEl.addEventListener('input', function () { update(true); });
    update(false);
  }

  /* ---------- Tool 7: Plattennutzung / Verschnitt ---------- */
  // Einfaches Rasterpacking (kein echtes Nesting): beide Orientierungen, bessere nehmen.
  function packDims(plateL, plateB, cutL, cutB, kerf) {
    var perRow = Math.max(0, Math.floor((plateL + kerf) / (cutL + kerf)));
    var rows = Math.max(0, Math.floor((plateB + kerf) / (cutB + kerf)));
    return { perRow: perRow, rows: rows, n: perRow * rows };
  }
  function initNesting(root) {
    var plEl = root.querySelector('[data-f="pl"]');
    var pbEl = root.querySelector('[data-f="pb"]');
    var clEl = root.querySelector('[data-f="cl"]');
    var cbEl = root.querySelector('[data-f="cb"]');
    var kerfEl = root.querySelector('[data-f="kerf"]');
    var qtyEl = root.querySelector('[data-f="qty"]');
    var out = root.querySelector('[data-f="out"]');
    if (!plEl || !pbEl || !clEl || !cbEl || !out) return;
    var LBL = toolLabel('Plattennutzungs-Rechner', 'Plate utilisation calculator', 'plattennutzung-rechner');

    var q = readParams(['pl', 'pb', 'cl', 'cb', 'kerf', 'qty']);
    setParam(plEl, q.pl); setParam(pbEl, q.pb); setParam(clEl, q.cl); setParam(cbEl, q.cb);
    setParam(kerfEl, q.kerf, true); setParam(qtyEl, q.qty);
    var api = cockpit(root, t('Teile pro Platte', 'Parts per plate'));

    function viz(pl, pb, w, h, kerf, dims) {
      var s = svgRoot(api.viz, 320, 200, t('Belegung der Platte', 'Plate layout'));
      if (!s) return;
      var sc = Math.min(296 / pl, 164 / pb);
      var W = pl * sc, Hh = pb * sc, x0 = (320 - W) / 2, y0 = 8;
      sv(s, 'rect', { x: x0, y: y0, width: W, height: Hh, class: 'vz-sheet' });
      var drawn = 0, cap = 600;
      for (var r = 0; r < dims.rows && drawn < cap; r++) {
        for (var c = 0; c < dims.perRow && drawn < cap; c++) {
          sv(s, 'rect', { x: x0 + c * (w + kerf) * sc, y: y0 + r * (h + kerf) * sc, width: Math.max(0.6, w * sc), height: Math.max(0.6, h * sc), class: 'vz-part' });
          drawn++;
        }
      }
      sv(s, 'text', { x: x0, y: y0 + Hh + 18, class: 'vz-label' }, de(pl) + ' × ' + de(pb) + ' mm');
      sv(s, 'text', { x: x0 + W, y: y0 + Hh + 18, 'text-anchor': 'end', class: 'vz-label vz-label--strong' }, dims.perRow + ' × ' + dims.rows + ' = ' + de(dims.n));
    }
    function update(fromUser) {
      var pl = num(plEl), pb = num(pbEl), cl = num(clEl), cb = num(cbEl);
      var kerf = kerfEl ? num(kerfEl) : 0;
      if (!(kerf >= 0)) kerf = 0;
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      if (!(pl > 0) || !(pb > 0) || !(cl > 0) || !(cb > 0)) {
        out.innerHTML = hint('Bitte Platten- und Zuschnittmaße eingeben.', 'Please enter plate and part dimensions.'); setBar(api, null, '–'); return;
      }
      var normal = packDims(pl, pb, cl, cb, kerf);
      var rotated = packDims(pl, pb, cb, cl, kerf);
      var isRot = rotated.n > normal.n;
      var best = isRot ? rotated : normal;
      var perPlate = best.n;
      if (!(perPlate > 0)) {
        out.innerHTML = hint('Der Zuschnitt passt in keiner Ausrichtung auf die Platte.', 'The part does not fit on the plate in either orientation.');
        setBar(api, null, '–'); if (api.viz) api.viz.innerHTML = '';
        return;
      }
      var platesNeeded = qty > 0 ? Math.ceil(qty / perPlate) : Math.ceil(1 / perPlate);
      var plateArea = (pl * pb) / 1e6;
      var usedArea = ((qty > 0 ? qty : perPlate) * (cl * cb)) / 1e6;
      var totalArea = platesNeeded * plateArea;
      var wastePct = totalArea > 0 ? Math.max(0, (1 - usedArea / totalArea) * 100) : 0;
      var sheetWord = platesNeeded === 1 ? t(' Platte', ' plate') : t(' Platten', ' plates');
      var vPerPlate = de(perPlate, 0) + t(' Stk.', ' pcs');
      var vPlates = de(platesNeeded, 0) + sheetWord;
      var vWaste = de(wastePct, 1) + t(' %', '%');
      out.innerHTML = grid([
        cell(t('Teile pro Platte', 'Parts per plate'), de(perPlate, 0)),
        cell(t('Benötigte Platten', 'Plates required'), de(platesNeeded, 0)),
        IS_EN ? cell('Waste', de(wastePct, 1) + '%') : cell('Verschnitt', de(wastePct, 1), '%')
      ]) + COPYHINT +
        note(t('Einfaches Rasterpacking (beide Ausrichtungen geprüft, ' + (isRot ? 'Zuschnitt gedreht' : 'Zuschnitt normal') + ' ergibt mehr Teile) mit ' + de(kerf, 1) + ' mm Schnittfuge. Echte Verschachtelungs-Software kann bei ungleichen Kantenlängen dichter packen — als grobe Materialplanung geeignet.',
               'Simple grid packing (both orientations checked, ' + (isRot ? 'rotated part' : 'part as entered') + ' gives more parts) with ' + de(kerf, 1) + ' mm kerf. Real nesting software can pack more densely with unequal edge lengths — suitable for rough material planning.')) +
        buildCta(LBL, vPerPlate + t(' pro Platte · ', ' per plate · ') + vPlates + t(' benötigt · Verschnitt ', ' required · waste ') + vWaste);
      enhanceCells(out); animateValues(out);
      announce(root, de(perPlate, 0) + t(' Teile pro Platte. ', ' parts per plate. ') + vPlates + t(' benötigt. Verschnitt ', ' required. Waste ') + vWaste + '.');
      buildExportBar(out, LBL, [
        { k: t('Teile pro Platte', 'Parts per plate'), v: de(perPlate, 0) },
        { k: t('Benötigte Platten', 'Plates required'), v: de(platesNeeded, 0) },
        { k: t('Verschnitt', 'Waste'), v: vWaste }
      ]);
      viz(pl, pb, isRot ? cb : cl, isRot ? cl : cb, kerf, best);
      setBar(api, t('Teile pro Platte · ', 'Parts per plate · ') + vPlates, de(perPlate, 0) + ' <small>' + t('Stk.', 'pcs') + '</small> · ' + vWaste);
      finish(root, api);
      if (fromUser) {
        track('nesting');
        writeParams({ pl: plEl.value, pb: pbEl.value, cl: clEl.value, cb: cbEl.value, kerf: kerfEl ? kerfEl.value : '', qty: qtyEl ? qtyEl.value : '' });
      }
    }
    [plEl, pbEl, clEl, cbEl].forEach(function (el) { el.addEventListener('input', function () { update(true); }); });
    if (kerfEl) kerfEl.addEventListener('input', function () { update(true); });
    if (qtyEl) qtyEl.addEventListener('input', function () { update(true); });
    update(false);
  }

  /* ---------- Tool 8: Zerspanvolumen (Zeitspanvolumen) ---------- */
  // Q = ap * ae * vf / 1000  [cm³/min]
  function initMrr(root) {
    var apEl = root.querySelector('[data-f="ap"]');
    var aeEl = root.querySelector('[data-f="ae"]');
    var vfEl = root.querySelector('[data-f="vf"]');
    var out = root.querySelector('[data-f="out"]');
    if (!apEl || !aeEl || !vfEl || !out) return;
    var LBL = toolLabel('Zerspanvolumen-Rechner', 'Material removal rate calculator', 'zerspanvolumen-rechner');
    var q = readParams(['ap', 'ae', 'vf']);
    setParam(apEl, q.ap); setParam(aeEl, q.ae); setParam(vfEl, q.vf);
    var api = cockpit(root, t('Zeitspanvolumen Q', 'Material removal rate Q'));

    function viz(ap, ae, vf) {
      var s = svgRoot(api.viz, 320, 180, t('Spanquerschnitt', 'Cut cross-section'));
      if (!s) return;
      arrowDefs(s, 'bztArrowM');
      var sc = Math.min(140 / ae, 100 / ap);
      var w = Math.max(6, ae * sc), h = Math.max(6, ap * sc);
      var x0 = 64, top = 44;
      sv(s, 'rect', { x: 20, y: top, width: 200, height: 118, class: 'vz-stock' });
      sv(s, 'rect', { x: x0, y: top, width: w, height: h, class: 'vz-groove' });
      dimH(s, x0, x0 + w, top - 12, 'ae ' + mm(ae));
      dimV(s, x0 - 12, top, top + h, 'ap ' + mm(ap));
      sv(s, 'line', { x1: 236, y1: 100, x2: 302, y2: 100, class: 'vz-arrow', 'marker-end': 'url(#bztArrowM)' });
      sv(s, 'text', { x: 268, y: 90, 'text-anchor': 'middle', class: 'vz-label' }, 'vf');
      sv(s, 'text', { x: 268, y: 120, 'text-anchor': 'middle', class: 'vz-label' }, de(vf) + ' mm/min');
    }
    function update(fromUser) {
      var ap = num(apEl), ae = num(aeEl), vf = num(vfEl);
      if (!(ap > 0) || !(ae > 0) || !(vf > 0)) {
        out.innerHTML = hint('Bitte Schnitttiefe, Schnittbreite und Vorschub eingeben.', 'Please enter depth of cut, width of cut and feed.'); setBar(api, null, '–'); return;
      }
      var Q = (ap * ae * vf) / 1000;
      var dec = Q < 10 ? 2 : (Q < 100 ? 1 : 0);
      var vQ = de(Q, dec) + ' cm³/min';
      var A = ap * ae;
      out.innerHTML = grid([
        cell(t('Zeitspanvolumen Q', 'Material removal rate Q'), de(Q, dec), 'cm³/min'),
        cell(t('Spanquerschnitt a<sub>p</sub> × a<sub>e</sub>', 'Cross-section a<sub>p</sub> × a<sub>e</sub>'), de(A, A < 10 ? 2 : 1), 'mm²')
      ]) + COPYHINT +
        note(t('Q = a<sub>p</sub> × a<sub>e</sub> × v<sub>f</sub> / 1000. Reine Geometrie des Zeitspanvolumens — sagt nichts über die benötigte Spindelleistung aus, die zusätzlich vom Material (spezifische Schnittkraft) abhängt. Höheres Q bedeutet mehr abgetragenes Material pro Minute, aber auch höhere Belastung für Werkzeug und Maschine.',
               'Q = a<sub>p</sub> × a<sub>e</sub> × v<sub>f</sub> / 1000. Q is purely geometric and does not indicate the spindle power required, which also depends on the material (specific cutting force). Higher Q means more material removed per minute, but also more load on tool and machine.')) +
        buildCta(LBL, t('Zeitspanvolumen Q ', 'Material removal rate Q ') + vQ);
      enhanceCells(out); animateValues(out);
      announce(root, t('Zeitspanvolumen ', 'Material removal rate ') + vQ + '.');
      buildExportBar(out, LBL, [{ k: t('Zeitspanvolumen Q', 'Material removal rate Q'), v: vQ }]);
      viz(ap, ae, vf);
      setBar(api, null, de(Q, dec) + ' <small>cm³/min</small>');
      finish(root, api);
      if (fromUser) { track('mrr'); writeParams({ ap: apEl.value, ae: aeEl.value, vf: vfEl.value }); }
    }
    [apEl, aeEl, vfEl].forEach(function (el) { el.addEventListener('input', function () { update(true); }); });
    update(false);
  }

  /* ---------- Tool 9: Bahnradius-Korrektur ---------- */
  // Bahnradius = Sollradius ∓ Werkzeugradius (Innen: minus, Außen: plus).
  // Innen darf der Werkzeugradius nicht ≥ Sollradius sein (passt nicht).
  function initRadius(root) {
    var modeEls = root.querySelectorAll('[data-f="mode"]');
    var rEl = root.querySelector('[data-f="r"]');
    var dEl = root.querySelector('[data-f="d"]');
    var out = root.querySelector('[data-f="out"]');
    if (!rEl || !dEl || !out) return;
    var LBL = toolLabel('Bahnradius-Rechner', 'Tool path radius calculator', 'bahnradius-rechner');
    var q = readParams(['mode', 'r', 'd']);
    if (q.mode === 'inner' || q.mode === 'outer') modeEls.forEach(function (el) { el.checked = el.value === q.mode; });
    setParam(rEl, q.r); setParam(dEl, q.d);
    var api = cockpit(root, t('Bahnradius', 'Path radius'));
    function mode() { var m = 'inner'; modeEls.forEach(function (el) { if (el.checked) m = el.value; }); return m; }

    function viz(R, tr, bahn, inner) {
      var s = svgRoot(api.viz, 320, 204, t('Kontur und Werkzeugbahn', 'Contour and tool path'));
      if (!s) return;
      var cx = 160, cy = 102, maxR = Math.max(R, bahn + tr);
      var sc = 88 / maxR;
      if (inner) sv(s, 'rect', { x: 18, y: 4, width: 284, height: 196, rx: 6, class: 'vz-stock' });
      sv(s, 'circle', { cx: cx, cy: cy, r: R * sc, class: inner ? 'vz-pocket' : 'vz-island' });
      sv(s, 'circle', { cx: cx, cy: cy, r: Math.max(1, bahn * sc), class: 'vz-path' });
      var a = -Math.PI / 4, tx = cx + Math.cos(a) * bahn * sc, ty = cy + Math.sin(a) * bahn * sc;
      sv(s, 'circle', { cx: tx, cy: ty, r: Math.max(2, tr * sc), class: 'vz-toolsmall' });
      sv(s, 'circle', { cx: tx, cy: ty, r: 2.2, class: 'vz-center' });
      sv(s, 'line', { x1: cx, y1: cy, x2: cx - R * sc, y2: cy, class: 'vz-dim' });
      sv(s, 'text', { x: cx - R * sc / 2, y: cy - 7, 'text-anchor': 'middle', class: 'vz-label' }, 'R ' + mm(R));
      sv(s, 'text', { x: Math.min(300, tx + Math.max(4, tr * sc) + 4), y: Math.max(14, ty - Math.max(4, tr * sc) - 2), 'text-anchor': tx > 250 ? 'end' : 'start', class: 'vz-label vz-label--strong' }, t('Bahn ', 'Path ') + mm(bahn));
    }
    function update(fromUser) {
      var R = num(rEl), d = num(dEl), tr = d / 2;
      if (!(R > 0) || !(d > 0)) { out.innerHTML = hint('Bitte Sollradius und Werkzeug-Durchmesser eingeben.', 'Please enter target radius and tool diameter.'); setBar(api, null, '–'); return; }
      var isInner = mode() === 'inner';
      if (isInner && tr >= R) {
        out.innerHTML = '<p class="bzt-calc__hint">' + t('<strong>Werkzeug passt nicht:</strong> Der Werkzeugradius (' + de(tr, 1) + ' mm) ist größer oder gleich dem Sollradius (' + de(R, 1) + ' mm). Für diese Innenkontur brauchen Sie ein schlankeres Werkzeug (Ø kleiner als ' + de(R * 2, 1) + ' mm).',
          '<strong>Tool does not fit:</strong> the tool radius (' + de(tr, 1) + ' mm) is greater than or equal to the target radius (' + de(R, 1) + ' mm). For this internal contour you need a slimmer tool (Ø smaller than ' + de(R * 2, 1) + ' mm).') + '</p>';
        setBar(api, null, '–'); if (api.viz) api.viz.innerHTML = '';
        return;
      }
      var bahn = isInner ? (R - tr) : (R + tr);
      var bDec = bahn < 10 ? 2 : 1;
      var vBahn = de(bahn, bDec) + ' mm';
      out.innerHTML = grid([
        cell(t('Bahnradius (Werkzeugmittelpunkt)', 'Path radius (tool centre)'), de(bahn, bDec), 'mm'),
        cell(t('Werkzeugradius', 'Tool radius'), de(tr, tr < 10 ? 2 : 1), 'mm')
      ]) + COPYHINT +
        note(isInner
          ? t('Innenkontur: Bahnradius = Sollradius − Werkzeugradius = ' + de(R, 1) + ' − ' + de(tr, 1) + ' = ' + vBahn + '. Programmieren Sie diesen Radius für den Werkzeugmittelpunkt, damit die Fräserkante exakt den Sollradius ' + de(R, 1) + ' mm erzeugt.',
              'Internal contour: path radius = target radius − tool radius = ' + de(R, 1) + ' − ' + de(tr, 1) + ' = ' + vBahn + '. Program this radius for the tool centre so that the cutting edge produces exactly the target radius of ' + de(R, 1) + ' mm.')
          : t('Außenkontur: Bahnradius = Sollradius + Werkzeugradius = ' + de(R, 1) + ' + ' + de(tr, 1) + ' = ' + vBahn + '. Programmieren Sie diesen Radius für den Werkzeugmittelpunkt, damit die Fräserkante exakt den Sollradius ' + de(R, 1) + ' mm erzeugt.',
              'External contour: path radius = target radius + tool radius = ' + de(R, 1) + ' + ' + de(tr, 1) + ' = ' + vBahn + '. Program this radius for the tool centre so that the cutting edge produces exactly the target radius of ' + de(R, 1) + ' mm.')) +
        buildCta(LBL, (isInner ? t('Innenkontur', 'Internal contour') : t('Außenkontur', 'External contour')) + ' · ' + t('Bahnradius ', 'Path radius ') + vBahn + t(' bei Sollradius ', ' at target radius ') + de(R, 1) + ' mm');
      enhanceCells(out); animateValues(out);
      announce(root, t('Bahnradius ', 'Path radius ') + vBahn + '.');
      buildExportBar(out, LBL, [{ k: t('Bahnradius (Werkzeugmittelpunkt)', 'Path radius (tool centre)'), v: vBahn }]);
      viz(R, tr, bahn, isInner);
      setBar(api, (isInner ? t('Innen', 'Inside') : t('Außen', 'Outside')) + ' · ' + t('Bahnradius', 'Path radius'), de(bahn, bDec) + ' <small>mm</small>');
      finish(root, api);
      if (fromUser) { track('radius'); writeParams({ mode: mode(), r: rEl.value, d: dEl.value }); }
    }
    modeEls.forEach(function (el) { el.addEventListener('change', function () { update(true); }); });
    rEl.addEventListener('input', function () { update(true); });
    dEl.addEventListener('input', function () { update(true); });
    update(false);
  }

  /* ---------- Tool 10: Drehzahl beim Drehen ---------- */
  // n = (vc * 1000) / (π * d), d = WERKSTÜCKDURCHMESSER. vc-Richtwerte für
  // Hartmetall-Wendeplatten, Außenlängsdrehen (Recherche 07/2026, konservativ).
  var TURN = {
    baustahl:  { label: 'Baustahl (S235, C45)', label_en: 'Mild steel (S235, C45)', vc: [120, 220],
                 hint: 'Bei zunehmender Festigkeit eher am unteren Ende der Spanne bleiben.', hint_en: 'With increasing strength stay towards the lower end of the range.' },
    vergstahl: { label: 'Vergütungsstahl (42CrMo4)', label_en: 'Heat-treatable steel (42CrMo4)', vc: [80, 160],
                 hint: 'Werte streuen stark je nach Festigkeitsstufe — bei hochfesten Sorten (>1000 N/mm²) eher am unteren Ende, bei weicheren Sorten am oberen.',
                 hint_en: 'Values vary strongly with strength grade — high-strength grades (>1000 N/mm²) towards the lower end, softer grades towards the upper.' },
    edelstahl: { label: 'Edelstahl (V2A/V4A)', label_en: 'Stainless steel (304/316)', vc: [100, 180],
                 hint: 'Kühlung wichtig, gleichmäßiger Vorschub gegen Kaltverfestigung — nicht am Werkstück reiben.', hint_en: 'Cooling is important, steady feed against work hardening — do not rub the workpiece.' },
    aluminium: { label: 'Aluminium (Knetlegierung)', label_en: 'Aluminium (wrought alloy)', vc: [250, 500],
                 hint: 'Sehr große Bandbreite je nach Legierung — bei aushärtbaren Sorten eher unteres, bei weichen/reinen Sorten oberes Ende.',
                 hint_en: 'Very wide range depending on alloy — age-hardenable grades towards the lower end, soft/pure grades towards the upper.' },
    messing:   { label: 'Messing / Bronze', label_en: 'Brass / bronze', vc: [150, 350],
                 hint: 'Gut zerspanbar, scharfe Werkzeuge verwenden.', hint_en: 'Machines well, use sharp tools.' },
    guss:      { label: 'Gusseisen (GG/GGG)', label_en: 'Cast iron (grey/ductile)', vc: [90, 200],
                 hint: 'Trockenbearbeitung meist möglich; Wert hängt stark vom Gefüge (ferritisch/perlitisch) ab.', hint_en: 'Dry machining usually possible; value depends strongly on the microstructure (ferritic/pearlitic).' }
  };
  function initTurn(root) {
    var matEl = root.querySelector('[data-f="mat"]');
    var dEl = root.querySelector('[data-f="d"]');
    var out = root.querySelector('[data-f="out"]');
    if (!matEl || !dEl || !out) return;
    fillSelect(matEl, TURN, 'baustahl');
    var LBL = toolLabel('Drehzahl-Rechner (Drehen)', 'Spindle speed calculator (turning)', 'drehzahl-rechner-drehen-');
    var q = readParams(['mat', 'd']);
    if (q.mat && TURN[q.mat]) matEl.value = q.mat;
    setParam(dEl, q.d);
    cards(root, matEl, function (k) { return 'vc ' + TURN[k].vc[0] + '–' + TURN[k].vc[1] + ' m/min'; });
    var api = cockpit(root, t('Drehzahl', 'Speed'));
    var gauge = api.viz && window.BZTTool ? window.BZTTool.gauge(api.viz) : null;

    function update(fromUser) {
      var m = TURN[matEl.value], d = num(dEl);
      if (!m || !(d > 0)) { out.innerHTML = hint('Bitte Werkstück-Durchmesser eingeben.', 'Please enter the workpiece diameter.'); setBar(api, null, '–'); return; }
      if (outOfRange(dEl, d)) { out.innerHTML = rangeHint(dEl, t('Werkstück-Ø', 'Workpiece Ø'), 'mm'); setBar(api, null, '–'); return; }
      var nLow = bztRoundAdaptive((m.vc[0] * 1000) / (Math.PI * d));
      var nHigh = bztRoundAdaptive((m.vc[1] * 1000) / (Math.PI * d));
      var range = nLow === nHigh ? de(nLow) : de(nLow) + '–' + de(nHigh);
      var k = t('Drehzahl (Hartmetall-Wendeplatte)', 'Speed (carbide insert)');
      out.innerHTML = grid([
        cell(k, range, RPM),
        cell(t('Schnittgeschwindigkeit v<sub>c</sub>', 'Cutting speed v<sub>c</sub>'), de(m.vc[0]) + '–' + de(m.vc[1]), 'm/min')
      ]) + COPYHINT +
        note(H(m) + t(' Richtwert für Außenlängsdrehen — die tatsächlich optimale Schnittgeschwindigkeit hängt zusätzlich von der genauen Legierung, Festigkeitsstufe und Wendeplattengeometrie ab.',
                      ' Reference value for external longitudinal turning — the actual optimum cutting speed also depends on the exact alloy, strength grade and insert geometry.')) +
        buildCta(LBL, L(m) + ' · ' + t('Werkstück-Ø ', 'Workpiece Ø ') + de(d, 0) + ' mm · ' + t('Drehzahl ', 'Speed ') + range + ' ' + RPM);
      enhanceCells(out); animateValues(out);
      announce(root, t('Drehzahl ', 'Speed ') + range + ' ' + t('Umdrehungen pro Minute.', 'revolutions per minute.'));
      buildExportBar(out, LBL, [{ k: k, v: range + ' ' + RPM }]);
      if (gauge) gauge.update({ lo: nLow, hi: nHigh, limit: null, bandLabel: t('Empfohlen ', 'Recommended ') + range + ' ' + RPM });
      setBar(api, t('Drehzahl · ', 'Speed · ') + L(m), range + ' <small>' + RPM + '</small>');
      finish(root, api);
      if (fromUser) { track('drehen'); writeParams({ mat: matEl.value, d: dEl.value }); }
    }
    matEl.addEventListener('change', function () { update(true); });
    dEl.addEventListener('input', function () { update(true); });
    update(false);
  }

  var INITS = { trochoidal: initTrochoidal, drill: initDrill, vcarve: initVcarve, weight: initWeight, thread: initThread, time: initTime, nesting: initNesting, mrr: initMrr, radius: initRadius, turn: initTurn };

  function boot() {
    document.querySelectorAll('[data-bzt-tool]').forEach(function (root) {
      var k = root.getAttribute('data-bzt-tool');
      if (INITS[k]) INITS[k](root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
